import { COOKIE_CONSENT_STORAGE_KEY } from './cookieConsentCatalog'

export const GOOGLE_CONSENT_DEFAULT_SCRIPT = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  analytics_storage: 'denied',
  ad_storage: 'denied',
});
`.trim()

export const GOOGLE_CONSENT_RESTORE_SCRIPT = `
(function () {
  try {
    var raw = localStorage.getItem('${COOKIE_CONSENT_STORAGE_KEY}');
    if (!raw) return;

    var parsed = JSON.parse(raw);
    if (!parsed || !parsed.expiresAt || Date.now() > parsed.expiresAt) {
      localStorage.removeItem('${COOKIE_CONSENT_STORAGE_KEY}');
      return;
    }

    var choices = parsed.choices || {};
    gtag('consent', 'update', {
      analytics_storage: choices.analytics_storage ? 'granted' : 'denied',
      ad_storage: choices.ad_storage ? 'granted' : 'denied',
    });
  } catch (e) {}
})();
`.trim()
